import PropTypes from 'prop-types'
import { Element } from '../html/element'
import classes from './index.module.scss'

const formatNum = (num) => {
  return num > 99 ? '99+' : num
}

export const Icon = ({ num, isTranslateTopRight }) => {
  const fontSize = 10

  return (
    <Element
      className={classes.icon}
      elementName="div"
      style={{
        backgroundColor: '#E0505B',
        borderRadius: 20,
        color: '#FFFFFF',
        fontSize,
        position: 'absolute',
        top: 0,
        right: 0,
        transform: isTranslateTopRight ? 'translate(80%,-30%)' : 'none',
      }}
    >
      {formatNum(num)}
    </Element>
  )
}

Icon.propTypes = {
  num: PropTypes.number.isRequired,
  isTranslateTopRight: PropTypes.bool,
}

Icon.defaultProps = {
  isTranslateTopRight: true,
}
